import { makeStyles } from '@material-ui/core/styles'
import { topbarHeight } from 'src/Constants'

export const userInfoStyle = makeStyles(theme => ({
  root: {
  },
  userIcon: {
    color: theme.palette.common.white,
    height: topbarHeight
  }
}))
